import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { persistLanguage } from "../../lib/i18n";
import i18n from "../../lib/i18n";
import { MarketingContext } from "../hooks/MarketingContext";
import { usePublicOffer } from "../hooks/usePublicOffer";
import { HASH_REDIRECTS, langFromPath, pagePath } from "../content/routes";
import { MarketingHeader } from "../components/navigation/MarketingHeader";
import { MarketingFooter } from "../components/navigation/MarketingFooter";

export function MarketingLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = langFromPath(location.pathname);
  const offerCall = usePublicOffer();
  const offer = offerCall.data?.message;
  const founderEnabled = Boolean(offer?.enable_founder_program);

  useEffect(() => {
    persistLanguage(lang);
    if (i18n.language !== lang) {
      void i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const hash = location.hash.replace(/^#/, "");
    const target = HASH_REDIRECTS[hash];
    if (target && (location.pathname === "/" || location.pathname === "/en" || location.pathname === "/es")) {
      navigate(pagePath(target, lang), { replace: true });
    }
  }, [lang, location.hash, location.pathname, navigate]);

  return (
    <MarketingContext.Provider
      value={{ lang, offer, offerLoading: Boolean(offerCall.isLoading), founderEnabled }}
    >
      <div className="min-h-screen bg-white font-sans text-foreground">
        <MarketingHeader />
        <Outlet />
        <MarketingFooter />
      </div>
    </MarketingContext.Provider>
  );
}
